import {Router} from 'ninelines-router';
import grid from './components/grid';
import modal from './components/modal';
import helpers from './helpers';
import home from './pages/home';
import analytics from './components/analytics';
import {randomCards} from './components/cards';

const modalToArrayEntries = Object.entries(window.data.modals);
let router = null;

const titles = {
	home: 'Victory Park | Главная',
	modal: 'Victory Park | Модальное окно',
};

history.scrollRestoration = 'manual';

helpers.canInteract(true);

function getPage(state) {
	let pageName = state.route.name !== 'home' ? 'modal' : state.route.name;

	return document.querySelector(`[data-page="${pageName}"]`);
}

function setPage($page) {
	if (!$page) {
		return;
	}

	helpers.$html.setAttribute('data-current-page', $page.dataset.page);
}

function setPageTitle(state) {
	let title;
	let pageName = state.route.name;

	for (let i = 0; i < modalToArrayEntries.length; i++) {
		const element = modalToArrayEntries[i];

		if (element[0] === state.params.id) {
			title = element[1].title;
		}
	}

	if (!title && typeof titles[pageName] !== 'undefined') {
		title = titles[pageName];
	}

	helpers.$title.innerHTML = title;
}

function enterDelay() {
	return new Promise((resolve) => {
		setTimeout(resolve, 500);
	});
}

function notFound() {
	router.navigate('/');

	return Promise.resolve();
}

async function enter(prevState, curState) {
	const $page = getPage(curState);

	const pageName = curState.route.name;
	const isModal = pageName !== 'home';

	if (!$page) {
		notFound();

		return Promise.resolve();
	}

	analytics.scrollDepth(isModal ? document.querySelector('.modal__scroller') : window);

	if (prevState.route) {
		analytics.scrollDepthReset(isModal ? window : document.querySelector('.modal__scroller'));
		analytics.virtualHit(location.pathname);

		setTimeout(() => {
			analytics.scrollDepth(isModal ? document.querySelector('.modal__scroller') : window);
		}, 100);
	}

	helpers.canInteract(false);

	setPage($page);
	setPageTitle(curState);

	if (prevState.route === null) {
		await enterDelay();

		randomCards().then(() => {
			grid.eventListener();
			modal.init();

			if (isModal) {
				home.partAnimation(isModal);
				modal.open(curState.params.id, document.querySelector(`[data-id="${curState.params.id}"]`), false);
			} else {
				home.fullAnimation(isModal);
			}
		});
	} else if (isModal && (prevState.route.name !== 'modal' || helpers.isMobile())) {
		modal.open(curState.params.id, document.querySelector(`[data-id="${curState.params.id}"]`));
	} else if (prevState.route.name === 'modal' && curState.route.name === 'modal' && !helpers.isMobile()) {
		modal.open(curState.params.id, document.querySelector(`[data-id="${curState.params.id}"]`), true);
	}

	helpers.canInteract(true);

	return Promise.resolve();
}

async function leave(curState, nextState) {
	if (curState.route === null || helpers.isMobile()) {
		return Promise.resolve();
	}

	const $page = getPage(curState);

	if (
		!$page ||
		!helpers.canInteract() ||
		curState.route.name === nextState.route.name &&
		curState.params && nextState.params && curState.params.id === nextState.params.id
	) {
		return Promise.reject();
	}

	helpers.canInteract(false);

	helpers.canInteract(true);

	return Promise.resolve();
}

router = new Router({
	onNotFound: notFound,
	onEnter: enter,
	onLeave: leave,
});

router.addRoute({
	path: '/',
	name: 'home',
});

router.addRoute({
	path: '/:id',
	name: 'modal',
});

router.start();

export default router;
